import { UserApis } from '../apis/user';
import { AuthToken, AuthTokenRefreshTime, LocalUser } from '../UserStorage';
export class UserService {
  static login(data) {
    return UserApis.login(data).then(res => {
      AuthToken.set(res.value?.token);
      AuthTokenRefreshTime.set(Date.now());
      // LoginPasswordExpired.set(res.value?.passwordExpired);
      LocalUser.setter(res.value);
      return res.value;
    });
  }
  static getUserInfo() {
    return UserApis.getUserInfo().then(res => {
      return res.value;
    });
  }
}